import { useEffect, useState } from 'react';

/**
 * Returns true once the window is scrolled past `threshold` px from the top, and false at/near the
 * top. Used for the topbar's scroll elevation, but generic enough for any sticky chrome (e.g. the
 * mobile topbar). Passive scroll listener that only re-renders when the boolean actually flips.
 * SSR-safe: the effect is client-only, so the initial (server) value is always false.
 *
 * @param {number} [threshold=4] scroll offset in px at which it flips to true
 * @returns {boolean}
 */
const useScrolledPast = (threshold = 4) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const isScrolled = window.scrollY > threshold;
      setScrolled(prev => (prev === isScrolled ? prev : isScrolled));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
};

export default useScrolledPast;
